export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any; }
};

/** Autogenerated input type of AddProjectToUser */
export type AddProjectToUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddProjectToUser. */
export type AddProjectToUserPayload = {
  __typename?: 'AddProjectToUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of AddUserToProject */
export type AddUserToProjectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddUserToProject. */
export type AddUserToProjectPayload = {
  __typename?: 'AddUserToProjectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  project?: Maybe<Project>;
};

/** Autogenerated input type of ChangePassword */
export type ChangePasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currentPassword: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  newPassword: Scalars['String']['input'];
};

/** Autogenerated return type of ChangePassword. */
export type ChangePasswordPayload = {
  __typename?: 'ChangePasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of CreateProject */
export type CreateProjectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactEmail: Scalars['String']['input'];
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

/** Autogenerated return type of CreateProject. */
export type CreateProjectPayload = {
  __typename?: 'CreateProjectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  project?: Maybe<Project>;
};

/** Autogenerated input type of Login */
export type LoginInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

/** Autogenerated return type of Login. */
export type LoginPayload = {
  __typename?: 'LoginPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  token?: Maybe<Token>;
  user?: Maybe<User>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Add a project to a user */
  addProjectToUser?: Maybe<AddProjectToUserPayload>;
  /** Add a user to a project */
  addUserToProject?: Maybe<AddUserToProjectPayload>;
  /** Change user password */
  changePassword?: Maybe<ChangePasswordPayload>;
  /** Create a new project */
  createProject?: Maybe<CreateProjectPayload>;
  /** Authenticate user and return JWT token */
  login?: Maybe<LoginPayload>;
  /** Remove a user from a project */
  removeUserFromProject?: Maybe<RemoveUserFromProjectPayload>;
  /** Create a new user account */
  signup?: Maybe<SignupPayload>;
  /** Update a project */
  updateProject?: Maybe<UpdateProjectPayload>;
  /** Update user profile */
  updateUser?: Maybe<UpdateUserPayload>;
};


export type MutationAddProjectToUserArgs = {
  input: AddProjectToUserInput;
};


export type MutationAddUserToProjectArgs = {
  input: AddUserToProjectInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationRemoveUserFromProjectArgs = {
  input: RemoveUserFromProjectInput;
};


export type MutationSignupArgs = {
  input: SignupInput;
};


export type MutationUpdateProjectArgs = {
  input: UpdateProjectInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

/** A nonprofit project */
export type Project = {
  __typename?: 'Project';
  contactEmail: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  status: ProjectStatus;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  users: Array<User>;
};

/** Project status */
export enum ProjectStatus {
  /** Project is actively being worked on */
  Active = 'active',
  /** Project has been cancelled */
  Cancelled = 'cancelled',
  /** Project has been completed */
  Completed = 'completed',
  /** Project is open for volunteers */
  Open = 'open',
  /** Project is pending review */
  PendingReview = 'pending_review',
  /** Project is in planning phase */
  Planning = 'planning'
}

export type Query = {
  __typename?: 'Query';
  /** Find a project by ID */
  project?: Maybe<Project>;
  /** List all projects */
  projects: Array<Project>;
  /** Find a user by ID */
  user?: Maybe<User>;
  /** List all users */
  users: Array<User>;
};


export type QueryProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};

/** Autogenerated input type of RemoveUserFromProject */
export type RemoveUserFromProjectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveUserFromProject. */
export type RemoveUserFromProjectPayload = {
  __typename?: 'RemoveUserFromProjectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  project?: Maybe<Project>;
};

/** Autogenerated input type of Signup */
export type SignupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  skills: Array<Skill>;
};

/** Autogenerated return type of Signup. */
export type SignupPayload = {
  __typename?: 'SignupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Programming skills and technologies */
export enum Skill {
  /** Angular framework */
  Angular = 'ANGULAR',
  /** Amazon Web Services */
  Aws = 'AWS',
  /** Microsoft Azure */
  Azure = 'AZURE',
  /** CI/CD */
  CiCd = 'CI_CD',
  /** C# programming */
  Csharp = 'CSHARP',
  /** CSS */
  Css = 'CSS',
  /** Django framework */
  Django = 'DJANGO',
  /** Docker */
  Docker = 'DOCKER',
  /** .NET framework */
  Dotnet = 'DOTNET',
  /** Flask framework */
  Flask = 'FLASK',
  /** Google Cloud Platform */
  Gcp = 'GCP',
  /** Git version control */
  Git = 'GIT',
  /** Go programming */
  Go = 'GO',
  /** GraphQL */
  Graphql = 'GRAPHQL',
  /** HTML */
  Html = 'HTML',
  /** Java programming */
  Java = 'JAVA',
  /** JavaScript programming */
  Javascript = 'JAVASCRIPT',
  /** Kubernetes */
  Kubernetes = 'KUBERNETES',
  /** MongoDB */
  Mongodb = 'MONGODB',
  /** MySQL */
  Mysql = 'MYSQL',
  /** Node.js runtime */
  Nodejs = 'NODEJS',
  /** NoSQL databases */
  Nosql = 'NOSQL',
  /** PHP programming */
  Php = 'PHP',
  /** PostgreSQL */
  Postgresql = 'POSTGRESQL',
  /** Python programming */
  Python = 'PYTHON',
  /** Ruby on Rails framework */
  Rails = 'RAILS',
  /** React framework */
  React = 'REACT',
  /** Redis */
  Redis = 'REDIS',
  /** REST APIs */
  Rest = 'REST',
  /** Ruby programming */
  Ruby = 'RUBY',
  /** Rust programming */
  Rust = 'RUST',
  /** Sass/SCSS */
  Sass = 'SASS',
  /** Spring framework */
  Spring = 'SPRING',
  /** SQL databases */
  Sql = 'SQL',
  /** Tailwind CSS */
  Tailwind = 'TAILWIND',
  /** Software testing */
  Testing = 'TESTING',
  /** TypeScript programming */
  Typescript = 'TYPESCRIPT',
  /** Vue.js framework */
  Vue = 'VUE'
}

/** JWT authentication token */
export type Token = {
  __typename?: 'Token';
  token: Scalars['String']['output'];
};

/** Autogenerated input type of UpdateProject */
export type UpdateProjectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateProject. */
export type UpdateProjectPayload = {
  __typename?: 'UpdateProjectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  project?: Maybe<Project>;
};

/** Autogenerated input type of UpdateUser */
export type UpdateUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  skills?: InputMaybe<Array<Skill>>;
};

/** Autogenerated return type of UpdateUser. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type User = {
  __typename?: 'User';
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  projects: Array<Project>;
  skills: Array<Skill>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string. */
export type __EnumValue = {
  __typename?: '__EnumValue';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __Field = {
  __typename?: '__Field';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  args: Array<__InputValue>;
  type: __Type;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};


/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __FieldArgsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value. */
export type __InputValue = {
  __typename?: '__InputValue';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  type: __Type;
  /** A GraphQL-formatted string representing the default value for this input value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __Type = {
  __typename?: '__Type';
  kind: __TypeKind;
  name?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  specifiedByURL?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<__Field>>;
  interfaces?: Maybe<Array<__Type>>;
  possibleTypes?: Maybe<Array<__Type>>;
  enumValues?: Maybe<Array<__EnumValue>>;
  inputFields?: Maybe<Array<__InputValue>>;
  ofType?: Maybe<__Type>;
  isOneOf?: Maybe<Scalars['Boolean']['output']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeEnumValuesArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeInputFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An enum describing what kind of type a given `__Type` is. */
export enum __TypeKind {
  /** Indicates this type is a scalar. */
  Scalar = 'SCALAR',
  /** Indicates this type is an object. `fields` and `interfaces` are valid fields. */
  Object = 'OBJECT',
  /** Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields. */
  Interface = 'INTERFACE',
  /** Indicates this type is a union. `possibleTypes` is a valid field. */
  Union = 'UNION',
  /** Indicates this type is an enum. `enumValues` is a valid field. */
  Enum = 'ENUM',
  /** Indicates this type is an input object. `inputFields` is a valid field. */
  InputObject = 'INPUT_OBJECT',
  /** Indicates this type is a list. `ofType` is a valid field. */
  List = 'LIST',
  /** Indicates this type is a non-null. `ofType` is a valid field. */
  NonNull = 'NON_NULL'
}

export type SignupMutationVariables = Exact<{
  input: SignupInput;
}>;


export type SignupMutation = { __typename?: 'Mutation', signup?: { __typename?: 'SignupPayload', errors: Array<string>, user?: { __typename?: 'User', id: string, name: string, email: string, skills: Array<Skill> } | null } | null };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login?: { __typename?: 'LoginPayload', errors: Array<string>, token?: { __typename?: 'Token', token: string } | null, user?: { __typename?: 'User', id: string, email: string, name: string, skills: Array<Skill>, projects: Array<{ __typename?: 'Project', id: string, name: string, description: string, contactEmail: string, status: ProjectStatus, createdAt: any }> } | null } | null };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'UpdateUserPayload', errors: Array<string>, user?: { __typename?: 'User', id: string, name: string, email: string, skills: Array<Skill> } | null } | null };

export type ChangePasswordMutationVariables = Exact<{
  input: ChangePasswordInput;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword?: { __typename?: 'ChangePasswordPayload', errors: Array<string>, user?: { __typename?: 'User', id: string, name: string, email: string, skills: Array<Skill> } | null } | null };

export type AddProjectToUserMutationVariables = Exact<{
  input: AddProjectToUserInput;
}>;


export type AddProjectToUserMutation = { __typename?: 'Mutation', addProjectToUser?: { __typename?: 'AddProjectToUserPayload', errors: Array<string>, user?: { __typename?: 'User', id: string, name: string, email: string, projects: Array<{ __typename?: 'Project', id: string, name: string, description: string, contactEmail: string }> } | null } | null };

export type GetUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, name: string, email: string, skills: Array<Skill>, createdAt: any, updatedAt: any, projects: Array<{ __typename?: 'Project', id: string, name: string, description: string, contactEmail: string, createdAt: any }> } | null };

export type GetUserProjectsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserProjectsQuery = { __typename?: 'Query', user?: { __typename?: 'User', projects: Array<{ __typename?: 'Project', id: string, name: string, description: string, contactEmail: string }> } | null };

export type GetProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectsQuery = { __typename?: 'Query', projects: Array<{ __typename?: 'Project', id: string, name: string, description: string, contactEmail: string, createdAt: any, updatedAt: any, slug: string, status: ProjectStatus, users: Array<{ __typename?: 'User', id: string, name: string, email: string }> }> };

export type GetProjectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, name: string, description: string, contactEmail: string, createdAt: any, updatedAt: any, slug: string, status: ProjectStatus, users: Array<{ __typename?: 'User', id: string, name: string, email: string }> } | null };

export type CreateProjectMutationVariables = Exact<{
  input: CreateProjectInput;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject?: { __typename?: 'CreateProjectPayload', project?: { __typename?: 'Project', id: string, name: string, description: string, status: ProjectStatus, slug: string } | null } | null };

export type AddUserToProjectMutationVariables = Exact<{
  input: AddUserToProjectInput;
}>;


export type AddUserToProjectMutation = { __typename?: 'Mutation', addUserToProject?: { __typename?: 'AddUserToProjectPayload', project?: { __typename?: 'Project', id: string, name: string, description: string, contactEmail: string, users: Array<{ __typename?: 'User', id: string, name: string, email: string }> } | null } | null };

export type RemoveUserFromProjectMutationVariables = Exact<{
  input: RemoveUserFromProjectInput;
}>;


export type RemoveUserFromProjectMutation = { __typename?: 'Mutation', removeUserFromProject?: { __typename?: 'RemoveUserFromProjectPayload', project?: { __typename?: 'Project', id: string, name: string, description: string, contactEmail: string, users: Array<{ __typename?: 'User', id: string, name: string, email: string }> } | null } | null };

export type UpdateProjectMutationVariables = Exact<{
  input: UpdateProjectInput;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject?: { __typename?: 'UpdateProjectPayload', project?: { __typename?: 'Project', id: string, name: string, description: string, contactEmail: string, status: ProjectStatus, users: Array<{ __typename?: 'User', id: string, name: string, email: string }> } | null } | null };

export type GetSkillsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSkillsQuery = { __typename?: 'Query', __type?: { __typename?: '__Type', name?: string | null, enumValues?: Array<{ __typename?: '__EnumValue', name: string, description?: string | null }> | null } | null };
